/**
 * general request axios
 * -
 * you can call basically every url you want
 * just pass it as params
 *
 * */
import axios from "axios";

export const general = {
  post: ({ url, payload, config }) => axios.post(url, payload, config),
  get: ({ url, params, config }) => axios.get(url, config, { params }),
  put: ({ url, payload, config }) => axios.put(url, payload, config),
  patch: ({ url, payload, config }) => axios.patch(url, payload, config),
};
